import React from 'react'
//import useScript from "./UseScript"
import { Helmet, HelmetProvider } from "react-helmet-async"

const GraphCard  = (props) => {
 
    return (
    <>
    <div className="col-lg-4 mt-4 mb-3">
          <div className="card z-index-2 ">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2 bg-transparent">
              <div className={"bg-gradient-"+props.color+" shadow-"+props.color+" border-radius-lg py-3 pe-1"}>
                <div className="chart">
                  <canvas id={"chart-tasks-"+ props.myid} className="chart-canvas" height="170"></canvas>
                </div>
              </div>
            </div>
            <div className="card-body">
              <h6 className="mb-0 ">{props.thetitle}</h6>
              <p className="text-sm ">{props.subtitle}</p>
              <hr className="dark horizontal" />
              <div className="d-flex ">
                <i className="material-icons text-sm my-auto me-1">schedule</i>
                <p className="mb-0 text-sm">{props.footer}</p>
              </div>
            </div>
          </div>
        </div>
      <HelmetProvider>
        
        <Helmet>
        <script>
        {`
        var ctx = document.getElementById("chart-tasks-${props.myid}").getContext("2d");

        new Chart(ctx, 
             {
            type: "line",
            data: {
                labels: ${props.labels},
                datasets: [{
                    label: "${props.alttext}",
                    tension: 0,
                    borderWidth: 0,
                    pointRadius: 5,
                    pointBackgroundColor: "rgba(255, 255, 255, .8)",
                    pointBorderColor: "transparent",
                    borderColor: "rgba(255, 255, 255, .8)",
                    borderWidth: 4,
                    backgroundColor: "transparent",
                    fill: true,
                    data: ${props.data},
                    maxBarThickness: 6

                    }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                legend: {
                    display: false,
                }
                },
                interaction: {
                intersect: false,
                mode: 'index',
                },
                scales: {
                y: {
                    grid: {
                    drawBorder: false,
                    display: true,
                    drawOnChartArea: true,
                    drawTicks: false,
                    borderDash: [5, 5],
                    color: 'rgba(255, 255, 255, .2)'
                    },
                    ticks: {
                    display: true,
                    padding: 10,
                    color: '#f8f9fa',
                    font: {
                        size: 14,
                        weight: 300,
                        family: "Roboto",
                        style: 'normal',
                        lineHeight: 2
                    },
                    }
                },
                x: {
                    grid: {
                    drawBorder: false,
                    display: false,
                    drawOnChartArea: false,
                    drawTicks: false,
                    borderDash: [5, 5]
                    },
                    ticks: {
                    display: true,
                    color: '#f8f9fa',
                    padding: 10,
                    font: {
                        size: 14,
                        weight: 300,
                        family: "Roboto",
                        style: 'normal',
                        lineHeight: 2
                    },
                    }
                },
                },
            },
 });
`}
        </script>
    </Helmet>
   
    </HelmetProvider>
    </>
    )
}

export default GraphCard;